import { Component, Injector } from '@angular/core';
import { ActivatedRoute, ResolveFn, Router } from '@angular/router';
import { OnboardingStatusService } from '@app/modules/self-serve/services/onboarding-status.service';
import { AbilityService, AuthService, NotifyService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { DocumentsV2Resolver } from '@documents-v2/documents-v2.resolver';
import {
    COMPANY_DOCUMENTS_TAB_MENU,
    companyDocumentsMenuServiceFactory,
} from '@documents-v2/menus/company-documents-show-menu.service';
import { Model } from '@models/core/base.model';
import { CompanyDocument } from '@models/documents/company-document.model';
import { DocumentTag } from '@models/documents/document-tag.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './company-document-show.template.html',
    styleUrls: ['./company-document-show.style.scss'],
    providers: [
        {
            provide: COMPANY_DOCUMENTS_TAB_MENU,
            useFactory: companyDocumentsMenuServiceFactory,
            deps: [
                AuthService,
                AbilityService,
                FeatureService,
                ActivatedRoute,
                OnboardingStatusService,
                TranslateService,
            ],
        },
    ],
})
export class CompanyDocumentShowView {
    companyDocument: CompanyDocument = new CompanyDocument();
    isLoading = true;
    allTags: DocumentTag[] = [];
    initialDocumentTags: DocumentTag[] = [];
    protected resolver: {
        resolve: ResolveFn<any>;
    };

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private injector: Injector,
        private notify: NotifyService,
        private auth: AuthService
    ) {
        this.resolver = this.injector.get(DocumentsV2Resolver);
        if (this.auth.can(CompanyDocument.permission.view)) {
            this.loadTags();
        }
        this.reResolve();
    }

    reResolve(): void {
        this.isLoading = true;
        this.resolver
            .resolve(this.route.snapshot, this.router.routerState.snapshot)
            .then((models: Map<string, Model>) => {
                this.companyDocument = <CompanyDocument>models.get('companyDocument');
                this.initialDocumentTags = [...this.companyDocument.documentTags];
                this.isLoading = false;
            })
            .catch((err: unknown) => (err as Error).message || 'document.documentReloadError');
    }

    private async loadTags(): Promise<void> {
        try {
            const [documentTags] = await DocumentTag.all();
            this.allTags = documentTags;
        } catch (err) {
            return this.notify.error(err);
        }
    }
}
